// Admin Glass Card Component
import React from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  padding?: string;
}

const GlassCard: React.FC<GlassCardProps> = ({
  children, className = '', hover = false, onClick, style = {}, padding = '24px',
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        background: '#FFFFFF',
        borderRadius: '16px',
        padding,
        boxShadow: '0 2px 16px rgba(12,34,57,0.055)',
        border: '1px solid rgba(12,34,57,0.05)',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
      className={`nln-card ${className}`}
      onMouseEnter={(e) => {
        if (hover || onClick) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 28px rgba(12,34,57,0.11)';
        }
      }}
      onMouseLeave={(e) => {
        if (hover || onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 16px rgba(12,34,57,0.055)';
        }
      }}
    >
      {children}
    </div>
  );
};

export default GlassCard;
